import React, { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import StyledCircularProgress from '../../../../../shared/components/StyledCircularProgress/StyledCircularProgress';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';
import './EmailPrevisualization.scss';

interface EmailPrevisualizationProps {
  html: string;
  message: string;
  loading: boolean;
}

const EmailPrevisualization = ({ html, message, loading }: EmailPrevisualizationProps) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const contentRef = useRef<HTMLDivElement>(null);
  const [scaledHeight, setScaledHeight] = useState(0);
  const { t } = useTranslation();

  const replacingVariables = {
    points: 'XX.XXX',
    customMessage: message,
    currentYear: currentYear.toString()
  };

  useEffect(() => {
    const updateHeight = () => {
      if (contentRef.current) {
        const originalHeight = contentRef.current.offsetHeight;
        const scale = 0.7;
        setScaledHeight(originalHeight * scale);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      setTimeout(updateHeight, 50);
    });

    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
      updateHeight();
    }

    return () => resizeObserver.disconnect();
  }, [html, message]);

  const replaceVariables = (template: string, variables: { [x: string]: string }) => {
    return template.replace(/\{\{\s*([^{}]*?)\s*\}\}/g, (_, key) => variables[key.trim()] || '');
  };

  const processedHtml = replaceVariables(html, replacingVariables);

  return (
    <div className="container">
      <p className="preview-title">{t(TRANSLATION_POINTS_BY_FILE.emailsConfiguration.previewTitle)}</p>
      <div className={`email-previsualization ${loading && 'loading'}`} style={{ height: scaledHeight }}>
        {loading && <StyledCircularProgress size={32} />}
        <div
          ref={contentRef}
          className="html-render"
          style={{ minHeight: '845px' }}
          dangerouslySetInnerHTML={{ __html: processedHtml }}
        />
        <button className="blocker" onClick={(e) => e.stopPropagation()} />
      </div>
    </div>
  );
};

export default EmailPrevisualization;
